export const REQUEST_APPLE_PAY_MERCHANT_SESSION =
  'src/ApplePay/REQUEST_APPLE_PAY_MERCHANT_SESSION'

export const CREATE_APPLE_PAYMENT = 'src/ApplePay/CREATE_APPLE_PAYMENT'
export const CREATE_APPLE_PAYMENT_FAILURE = 'CREATE_APPLE_PAYMENT_FAILURE'
export const CREATE_APPLE_PAYMENT_LINK_REL = 'ApplePay request'
